import { render, staticRenderFns } from "./courseFile.vue?vue&type=template&id=f4db8b20&scoped=true&"
import script from "./courseFile.vue?vue&type=script&lang=js&"
export * from "./courseFile.vue?vue&type=script&lang=js&"
import style0 from "./courseFile.vue?vue&type=style&index=0&id=f4db8b20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4db8b20",
  null
  
)

export default component.exports